import React, { Component } from 'react';
import { Button, Container, Divider, Form, Grid, Message } from 'semantic-ui-react'
import { callService, GET, POST } from "../../shared/serviceInvoker";
import { contactDataURL, contactUsURL } from "../../shared/urls/clientapi";
import { checkEmail, checkRequired } from "../../shared/helpers/validators";
import MessageError from "../../shared/components/MessageError";
import { returnErrorMessage } from "../../shared/utils";
import ReactGA from 'react-ga';
import { trackEvent } from '../../shared/tracking';

export default class ContactForm extends Component {
    constructor(props) {
        super(props);
        this.myContactDataURL = contactDataURL.replace('{contact_id}', sessionStorage.contact_id);

        this.state = {
            success: false,
            error: false,
            errorMessage: '',
            name: '',
            email: '',
            phone: '',
            subject: '',
            message: '',
            formValid: false,
            emailValid: false,
            nameRequired: false,
            emailRequired: false,
            phoneRequired: false,
            subjectRequired: false,
            messageRequired: false,
            showSuccessMsg: false,
        };

        if (sessionStorage.contact_id) {
            callService(
                GET,
                this.myContactDataURL,
                {},
                response => {
                    if (response.data.data) {
                        const data = response.data.data;
                        this.setState(
                            {
                                name: data.first_name + ' ' + data.last_name,
                                email: data.email,
                                phone: data.mobile_number,
                            }
                        );
                        this.validateField('name', data.first_name + ' ' + data.last_name);
                        this.validateField('email', data.email);
                        this.validateField('phone', data.mobile_number);
                    }
                },
                error => {
                    this.setState({ error: true });
                },
            );
        }

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleNumberOnlyChange = this.handleNumberOnlyChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.validateField = this.validateField.bind(this);
        this.validateForm = this.validateForm.bind(this);
    }

    handleNumberOnlyChange(event) {
        const target = event.target;
        const value = target.value.replace(/\D/, '');
        const name = target.name;

        this.setState(
            { [name]: value },
            () => { this.validateField(name, value) }
        );
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState(
            { [name]: value },
            () => { this.validateField(name, value) }
        );
    }

    validateField(fieldName, value) {
        let emailValid = this.state.emailValid;
        let nameRequired = this.state.nameRequired;
        let phoneRequired = this.state.phoneRequired;
        let subjectRequired = this.state.subjectRequired;
        let messageRequired = this.state.messageRequired;

        switch (fieldName) {
            case 'email':
                emailValid = checkEmail(value);
                break;
            case 'name':
                nameRequired = checkRequired(value);
                break;
            case 'phone':
                phoneRequired = checkRequired(value);
                break;
            case 'subject':
                subjectRequired = checkRequired(value);
                break;
            case 'message':
                messageRequired = checkRequired(value);
                break;
            default:
                break;
        }
        this.setState(
            {
                emailValid: emailValid,
                nameRequired: nameRequired,
                phoneRequired: phoneRequired,
                subjectRequired: subjectRequired,
                messageRequired: messageRequired
            },
            this.validateForm
        )
    }

    validateForm() {
        this.setState(
            {
                formValid: this.state.emailValid && this.state.phoneRequired && this.state.nameRequired
                    && this.state.subjectRequired && this.state.messageRequired
            }
        )
    }

    handleSubmit = (event) => {
        event.preventDefault();
        const { name, email, phone, subject, message } = this.state;

        let bodyFormData = new FormData();
        bodyFormData.append('name', name);
        bodyFormData.append('email', email);
        bodyFormData.append('phone', phone);
        bodyFormData.append('subject', subject);
        bodyFormData.append('message', message);
        bodyFormData.append('contact_id', sessionStorage.contact_id);

        callService(
            POST,
            contactUsURL,
            bodyFormData,
            response => {
                this.setState({ success: true, error: false });

                ReactGA.event({
                    category: 'Contact Us',
                    action: 'Contact Us Form Submitted',
                });
                trackEvent('Contact Us', 'Contact Us Form Submitted');
            },
            error => {
                let msg = returnErrorMessage(error, "DefaultSaveError");
                this.setState({ success: false, error: true, errorMessage: msg });
            }
        );
    };

    render() {
        const errors = {
            email: 'Enter a valid email address.',
            phone: 'Enter a valid number.',
            name: 'This field is required.',
            subject: 'This field is required.',
            message: 'This field is required.',
        };

        return (
            <div>
                <Container>

                    <Grid textAlign='center'>
                        <Grid.Column style={{ maxWidth: 450 }} textAlign='left'>
                            <h3>Support Request</h3>
                            If you'd like someone to contact you regarding a question or concern, fill out and submit the following form and a support representative will reach out to you.
                            <Form onSubmit={this.handleSubmit}>
                                <Divider hidden />
                                <Container>

                                    <label htmlFor="name" style={{ display: 'block', textAlign: 'left' }}>Your Name *</label>
                                    <Form.Input
                                        name='name'
                                        value={this.state.name}
                                        type='text'
                                        onChange={this.handleInputChange}
                                        maxLength={50}
                                        className={this.state.nameRequired ? 'text-input' : 'text-input error'}
                                    />
                                    {
                                        !this.state.nameRequired ? <MessageError message={errors.name} /> : null
                                    }
                                    <Divider hidden />

                                    <label htmlFor="email" style={{ display: 'block', textAlign: 'left' }}>Your Email *</label>
                                    <Form.Input
                                        name='email'
                                        value={this.state.email}
                                        type='text'
                                        onChange={this.handleInputChange}
                                        maxLength={150}
                                        className={this.state.emailValid ? 'text-input' : 'text-input error'}
                                    />
                                    {!this.state.emailValid ? <MessageError message={errors.email} /> : null}
                                    <Divider hidden />

                                    <label htmlFor="phone" style={{ display: 'block', textAlign: 'left' }}>Your Phone *</label>
                                    <Form.Input
                                        name='phone'
                                        value={this.state.phone}
                                        type='text'
                                        onChange={this.handleNumberOnlyChange}
                                        maxLength={10}
                                        className={this.state.phoneRequired ? 'text-input' : 'text-input error'}
                                    />
                                    {
                                        !this.state.phoneRequired ? <MessageError message={errors.phone} /> : null
                                    }
                                    <Divider hidden />

                                    <label htmlFor="subject" style={{ display: 'block', textAlign: 'left' }}>Subject *</label>
                                    <Form.Input
                                        name='subject'
                                        value={this.state.subject}
                                        type='text'
                                        onChange={this.handleInputChange}
                                        maxLength={100}
                                        className={this.state.subjectRequired ? 'text-input' : 'text-input error'}
                                    />
                                    {
                                        !this.state.subjectRequired ? <MessageError message={errors.subject} /> : null
                                    }
                                    <Divider hidden />

                                    <label htmlFor="message" style={{ display: 'block', textAlign: 'left' }}>Your Message *</label>
                                    <Form.TextArea
                                        name='message'
                                        value={this.state.message}
                                        type='text'
                                        onChange={this.handleInputChange}
                                        maxLength={1000}
                                        className={this.state.messageRequired ? 'text-input' : 'text-input error'}
                                    />
                                    {
                                        !this.state.messageRequired ? <MessageError message={errors.message} /> : null
                                    }
                                    <Divider hidden />

                                </Container>

                                <Divider />
                                <Container>
                                    {
                                        this.state.success ?
                                            <Message size='tiny' color='green' icon='checkmark' content='Thank you for reaching out to us. We will be contacting you shortly.' /> : null
                                    }
                                    {
                                        this.state.error ?
                                            <Message size='tiny' color='red'>
                                                <div dangerouslySetInnerHTML={{ __html: this.state.errorMessage }} />
                                            </Message> : null
                                    }
                                    <Button
                                        icon='save'
                                        type='submit'
                                        primary
                                        disabled={!this.state.formValid}
                                        content='Send'
                                    />

                                </Container>
                            </Form>
                        </Grid.Column>
                    </Grid>
                </Container>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/ContactForm/index.js